class Follow {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const $follow = $('.' + this.el);
    const footer = document.querySelector('.js-footer');
    const mq = window.matchMedia('(max-width: 767px)');
    const threshold = 80;
    let footerVisible = false;

    const update = () => {
      const shouldShow = mq.matches && window.scrollY > threshold && !footerVisible;
      $follow.toggleClass('is-show', shouldShow);
      $follow.attr('aria-hidden', shouldShow ? 'false' : 'true');
    };

    if (footer) {
      const observer = new IntersectionObserver((entries) => {
        footerVisible = entries.some((entry) => entry.isIntersecting);
        update();
      }, {
        threshold: 0
      });
      observer.observe(footer);
    }

    $(window).on('scroll', update);
    $(window).on('resize', update);

    if (mq.addEventListener) {
      mq.addEventListener('change', update);
    } else if (mq.addListener) {
      mq.addListener(update);
    }

    update();
  }
}
